import { privateAxios } from "../../../config/apiConfig";
import { getAllCategory } from "../Category/Action";
import {
  CREATE_PRODUCTCATEGORY_FAILURE,
  CREATE_PRODUCTCATEGORY_REQUEST,
  GET_ALL_PRODUCTCATEGORY_SUCCESS,
  GET_ALL_PRODUCTCATEGORY_REQUEST,
  GET_ALL_PRODUCTCATEGORY_FAILURE,
  DELETE_PRODUCTCATEGORY_REQUEST,
  DELETE_PRODUCTCATEGORY_FAILURE,
  UPDATE_PRODUCTCATEGORY_REQUEST,
  UPDATE_PRODUCTCATEGORY_FAILURE,
} from "./ActionType";
import { toast } from "react-toastify";

export const getAllProductCategory = () => async (dispatch) => {
  dispatch({ type: GET_ALL_PRODUCTCATEGORY_REQUEST });
  try {
    const { data } = await privateAxios.get(`admin/productCategories`);
    dispatch({ type: GET_ALL_PRODUCTCATEGORY_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_PRODUCTCATEGORY_FAILURE, payload: error.message });
  }
};

export const createProductCategory = (productCategoryData, subCategoryId, formData) => async (dispatch) => {
  dispatch({ type: CREATE_PRODUCTCATEGORY_REQUEST });
  try {
    const { data } = await privateAxios.post(`admin/productCategory/subCategory/${subCategoryId}`, productCategoryData);
    if (data) {
      const { res } = await privateAxios.put(
        `admin/productCategory/${data.id}/upload`,
        formData,
        {
          headers: { "Content-Type": "multipart/form-data" }
        }
      );
      dispatch(getAllCategory());
      toast.success("ProductCategory Created Successfully");
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: CREATE_PRODUCTCATEGORY_FAILURE, payload: error.message });
  }
};


export const updateProductCategory = (productCategoryId, productCategoryData, formData) => async (dispatch) => {
  dispatch({ type: UPDATE_PRODUCTCATEGORY_REQUEST });
  try {
    const { data } = await privateAxios.put(
      `admin/productCategory/${productCategoryId}`,
      productCategoryData
    );
    if (data.status === "SUCCESS") {
      if (formData && formData.get("imageFile") && formData.get("imageFile").name) {
        const { res } = await privateAxios.put(
          `admin/productCategory/${productCategoryId}/upload`,
          formData,
          {
            headers: { "Content-Type": "multipart/form-data" }
          }
        );
      }
      dispatch(getAllCategory());
      toast.success("ProductCategory Updated Successfully");
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: UPDATE_PRODUCTCATEGORY_FAILURE, payload: error.message });
  }
};

export const deleteProductCategory = (productCategoryId) => async (dispatch) => {
  dispatch({ type: DELETE_PRODUCTCATEGORY_REQUEST });
  try {
    const { data } = await privateAxios.delete(`admin/productCategory/${productCategoryId}`);
    if (data.status === "SUCCESS") {
      dispatch(getAllCategory());
      toast.success(data.response);
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: DELETE_PRODUCTCATEGORY_FAILURE, payload: error.message });
  }
};
